// Generated by OrchestKit Claude Plugin
// Created: 2026-09-11

/** Contrats de l'écran Résultats — une ligne par boutique. */

export interface LigneResultat {
  boutique_id: string;
  code: string;
  nom: string;
  ventes: number;
  chiffre_affaires: number;
  panier_moyen: number;
  remises: number;
  contrepassations: number;
  montant_contrepasse: number;
  sessions_fermees: number;
  sessions_en_ecart: number;
  ecart_cumule: number;
  encours_client: number;
  encours_echu: number;
  /** Absents sans `rapport.marge.lire` : non calculés, pas masqués (RG-143). */
  marge?: number;
  taux_marge_pct?: number;
  /** Absente sans `stock.cout.lire`. */
  valeur_stock?: number;
}

export interface Resultats {
  periode: { depuis: string; jusqu_a: string };
  lignes: LigneResultat[];
}

/** Ventes par article, groupées par boutique — onglet « Par article ». */
export interface LigneArticleResultat {
  produit_id: string;
  reference: string;
  designation: string;
  quantite: number;
  chiffre_affaires: number;
}

export interface ResultatBoutiqueArticles {
  boutique_id: string;
  code: string;
  nom: string;
  quantite_totale: number;
  chiffre_affaires_total: number;
  articles: LigneArticleResultat[];
}

export interface ResultatsParArticle {
  periode: { depuis: string; jusqu_a: string };
  boutiques: ResultatBoutiqueArticles[];
}

/** Premier jour du mois en cours : la période que l'on regarde le plus. */
export function debutDuMois(): string {
  const maintenant = new Date();
  const mois = String(maintenant.getMonth() + 1).padStart(2, '0');
  return `${String(maintenant.getFullYear())}-${mois}-01`;
}
